<template>
  <div :class="classObj" class="app-wrapper" :style="{ '--current-color': theme }">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />

    <!-- <div class="resize" title="收缩侧边栏">⋮AAAA</div> -->
    <!-- 
    <div class="content-warp-icon">
    </div> -->

    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel>
        <settings />
      </right-panel>
    </div>
    <audio
      id="audio-player"
      src="@/assets/images/baojing.mp3"
      style="display: none"
      ref="audio"
    ></audio>
    <!-- <el-button @click="playDemo">playDemo</el-button> -->
  </div>
</template>

<script>
import RightPanel from "@/components/RightPanel";
import { AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import variables from "@/assets/styles/variables.scss";
import { createSocket, sendWSPush } from "@/utils/websocket";
import { read } from "@/api/websocket/websocket";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      websocketType: [],
      message: [],
    };
  },
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      theme: (state) => state.settings.theme,
      sideTheme: (state) => state.settings.sideTheme,
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      voice: (state) => state.user.voice,
      popup: (state) => state.user.popup,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
    variables() {
      return variables;
    },
  },
  mounted() {
    this.dragControllerDiv();
    this.getDicts("websocket_type").then((res) => {
      if (res.data) {
        this.websocketType = res.data;
        let socketUrl = process.env.VUE_APP_BASE_API_WS + this.$store.state.user.token;
        Cookies.set("socketUrl", socketUrl);
        createSocket(socketUrl);
        this.provide();
        this.customer();
      }
    });
  },
  methods: {
    dragControllerDiv() {
      var resize = document.getElementsByClassName("content-warp-icon");
      var left = document.getElementsByClassName("sidebar-container");
      var mid = document.getElementsByClassName("main-container");
      var box = document.getElementsByClassName("app-wrapper");
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          resize[i].style.background = "#818181";
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + "px";
              mid[j].style.width = box[i].clientWidth - moveLen - 10 + "px";
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
    provide() {
      this.getSocketData = async (e) => {
        // console.log(e);
        if (e.detail.data == "登录未认证") return;
        let message = JSON.parse(e.detail.data);
        if (message.type === "1") {
          this.$prompt("请输入查岗答案:" + message.message, "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            // cancelButtonText: '取消',
            showClose: false,
          })
            .then(({ value }) => {
              read({ id: message.id, answer: value });
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '取消输入'
              // });
            });
        } else if (message.type === "3") {
          // 当是强制退出的时候
          this.message = [];
          this.$notify({
            title: this.getLabel("管理员正在强制退出，请重新登录"),
            message: "管理员正在强制退出，请重新登录",
            position: "bottom-right",
          });
          this.$store.dispatch("LogOut").then(() => {
            location.href = "/index";
          });
        } else {
          this.message.push(message);
        }
      };
      // 注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
    },

    async customer() {
      while (true) {
        if (this.message.length === 0) {
          await this.sleep(2000);
          continue;
        }
        let message = this.message[0];
        if (message.id) {
          await read({ id: message.id }).then((res) => {
            if (res.code !== 200) {
              return;
            }
          });
        }
        // 当车辆报警时查看是否需要展示
        if (message.type === "2") {
          if (this.popup) {
            this.$notify({
              title: this.getLabel(message.type),
              message: this.getMessage(message.message),
              dangerouslyUseHTMLString: true,
              position: "bottom-right",
            });
          }

          if (this.voice) {
            this.$refs.audio.play();
          }
        } else {
          // 其他报警直接展示
          this.$notify({
            title: this.getLabel(message.type),
            message: this.getMessage(message.message),
            dangerouslyUseHTMLString: true,
            position: "bottom-right",
          });

          if (this.voice) {
            this.$refs.audio.play();
          }
        }

        this.message.shift();

        await this.sleep(1000);
      }
    },
    getLabel(type) {
      let name = null;
      this.websocketType.forEach((item) => {
        if (item.dictValue === type) {
          name = item.dictLabel;
        }
      });
      return name;
    },

    getMessage(message) {
      return message.replace(/(\r\n)|(\n)/g, "<br>");
    },

    imitateClick() {
      let element = document.createEvent("MouseEvents");
      element.initMouseEvent("click", true, true, document.defaultView, 0, 0, 0, 1, -1);
      document.body.dispatchEvent(element);
    },

    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
@import "~@/assets/styles/variables.scss";
/*拖拽区div样式*/
.content-warp-icon {
  float: left;
  position: relative;
  height: calc(100vh - 124px);
  line-height: 45;
  font-size: 12px;
  margin-left: 230px;

  cursor: col-resize;
  z-index: 99999;
  /*top: 45%;*/
  background-color: #f23f3f;
  border-radius: 5px;
  width: 0.5%;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  color: white;

  i {
    color: #fff;
    background-color: #999;
    padding: 20px 0;
  }
  i:hover {
    cursor: pointer;
  }
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
